<nice-layout *ngIf="hasRegistered$ | async; else registerCitizen">
    <div class="mx-auto grid min-h-dvh h-dvh max-w-screen-lg gap-12 p-8 overflow-y-auto md:grid-cols-2 md:h-auto">
        <div class="mx-auto flex w-full max-w-100 justify-center sm:py-8 md:py-16">
            <div class="flex flex-col items-center justify-center gap-12">
                <div *ngIf="organisation$ | async as organisation" class="flex w-full flex-col">
                    <div class="w-full">
                        <img [src]="organisation.logo" />
                    </div>

                    <div class="flex w-full select-none items-end justify-end gap-3">
                        <div class="subtitle lowercase">{{ "features.root.powered_by" | translate }}</div>
                        <img class="w-28" src="assets/images/logo-municipal.svg" />
                    </div>
                </div>
            </div>
        </div>

        <div class="mx-auto flex w-full max-w-100 flex-col items-center justify-center gap-8 sm:gap-16 md:pb-8">
            <div class="w-full max-w-64">
                <img src="assets/images/register-success.svg" />
            </div>

            <span class="intertitle text-center">{{ "features.register.success" | translate }}</span>

            @if (isLoggedIn$ | async) {
                <a mat-flat-button class="w-full" color="accent" [routerLink]="['../dashboard/home']">
                    {{ "features.register.go_to_dashboard" | translate }}
                </a>
            } @else {
                <a mat-flat-button class="w-full" color="accent" [routerLink]="['..']">
                    {{ "features.register.back_to_login" | translate }}
                </a>
            }
        </div>
    </div>
</nice-layout>

<ng-template #registerCitizen>
    <nice-layout *ngIf="owner$ | async as owner; else enterCode">
        <div class="mx-auto grid min-h-dvh h-dvh max-w-screen-lg gap-12 p-8 overflow-y-auto md:grid-cols-2 md:h-auto">
            <div class="mx-auto flex w-full max-w-100 justify-center sm:py-8 md:py-16">
                <div class="flex flex-col items-center justify-center gap-12">
                    <div *ngIf="organisation$ | async as organisation" class="flex w-full flex-col">
                        <div class="w-full">
                            <img [src]="organisation.logo" />
                        </div>

                        <div class="flex w-full select-none items-end justify-end gap-3">
                            <div class="subtitle lowercase">{{ "features.root.powered_by" | translate }}</div>
                            <img class="w-28" src="assets/images/logo-municipal.svg" />
                        </div>
                    </div>

                    <div class="flex flex-col gap-4 md:hidden">
                        <div class="text-5xl font-extrabold text-primary">
                            {{ "features.register.welcome" | translate }}
                        </div>
                        <div class="text-xl font-semibold text-primary">
                            {{ "features.register.password_description" | translate }}
                        </div>
                    </div>

                    <div class="flex w-full flex-col items-start gap-16 md:pb-8">
                        <mat-card class="flex w-full flex-col gap-4 border border-accent p-5">
                            <div class="card-element">
                                <span class="intertitle text-accent">
                                    {{ "features.register.citizen_info" | translate }}
                                </span>
                            </div>

                            <div class="card-element">
                                <mat-icon svgIcon="streamline-regular:multiple-actions-key" />
                                <span>{{ owner.fullName }}</span>
                            </div>

                            <div class="card-element">
                                <mat-icon svgIcon="streamline-regular:maps-pin-1" />
                                <span>{{ owner.property?.address | formatLongAddress }}</span>
                            </div>
                        </mat-card>
                    </div>
                </div>
            </div>

            <div class="mx-auto flex w-full max-w-100 flex-col items-center justify-center gap-16 md:pb-8">
                <div class="hidden flex-col gap-4 md:flex">
                    <div class="text-5xl font-extrabold text-primary">
                        {{ "features.register.welcome" | translate }}
                    </div>
                    <div class="text-xl font-semibold text-primary">
                        {{ "features.register.password_description" | translate }}
                    </div>
                </div>

                <nerri-register-owner-form
                    class="w-full"
                    [saving]="(loading$ | async) ?? false"
                    (register)="register($event)"
                />
            </div>
        </div>
    </nice-layout>
</ng-template>

<ng-template #enterCode>
    <nerri-public-page [organisationLogo]="(organisation$ | async)?.logo ?? null">
        <section class="flex w-full flex-col items-start gap-4">
            <div class="text-5xl font-extrabold text-primary">{{ "features.register.welcome" | translate }}</div>
            <div class="text-xl font-semibold text-primary">{{ "features.register.description" | translate }}</div>
        </section>

        <nerri-register-owner-code-form
            class="w-full"
            [hasValidationError]="(hasValidationError$ | async) ?? false"
            [validating]="(loading$ | async) ?? false"
            (code)="validateCode($event)"
        />
    </nerri-public-page>
</ng-template>
